import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "question-content tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] tw-p-10" }
const _hoisted_2 = { class: "tw-bg-[#387DFF] tw-inline-flex tw-px-[5px] tw-py-[3px] tw-rounded tw-mr-[10px]" }
const _hoisted_3 = { class: "tw-text-white tw-text-[11px] tw-font-medium tw-leading-[130%]" }
const _hoisted_4 = { class: "tw-bg-[#F2F8FF] tw-inline-flex tw-px-[5px] tw-py-[3px] tw-rounded" }
const _hoisted_5 = { class: "tw-text-[#387DFF] tw-text-[11px] tw-font-medium tw-leading-[130%]" }
const _hoisted_6 = { class: "tw-mt-[12px]" }
const _hoisted_7 = { class: "tw-mr-[15px] tw-font-semibold tw-text-[20px] tw-text-[#211F58]" }
const _hoisted_8 = { class: "tw-font-normal tw-text-[20px] tw-text-[#211F58]" }
const _hoisted_9 = {
  key: 0,
  class: "tw-p-[40px] tw-pb-[40px]"
}
const _hoisted_10 = { class: "tw-text-[#211F58] tw-text-lg tw-font-semibold tw-mb-[20px]" }
const _hoisted_11 = { class: "tw-flex tw-items-center tw-mx-[40px] tw-justify-between" }
const _hoisted_12 = { class: "tw-text-[#211F58] tw-text-lg tw-font-semibold" }
const _hoisted_13 = { class: "tw-px-[40px] tw-mt-[15px]" }
const _hoisted_14 = {
  key: 0,
  class: "overlay"
}
const _hoisted_15 = ["src"]

import utilities, { getComponentUiText } from "@/utils/utilities";
import { ComputedRef, Ref, onMounted, ref, watch } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import ModalImage from "@/components/common/modalComponent.vue";
import {
  IAssessmentQuestion,
  IAssessmentQuestionFile,
} from "@/interfaces/assessments/IAssessmentQuestion";
import { PropType } from "vue";
import FileUploader from "../common/fileUploader.vue";
import CustomTable from "../common/customTable.vue";
import {
  ACCEPTABLE_FILE_TYPE,
  API_STATUS_LOADING,
  ASSESSMENT_ANSWER_STORE_TYPE,
  CHECKLIST_TYPE,
  MODAL_NAME,
  TYPE_MODAL_SECURING_EVIDENCE,
  actionClickType,
  checklistStatusId,
  localStorageKey,
  successStatusCodes,
} from "@/utils/constants";
import CellTableInfo from "../common/setting/cellTableInfo.vue";
import CellTableAction from "../common/setting/cellTableAction.vue";
import {
  convertUTCTimeToLocalTime,
  fileSizeFormat,
} from "@/utils/dateTimeUtils";
import ButtonBulkActions from "../common/setting/buttonBulkActions.vue";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import store from "@/store";
import {
  postUploadFile,
  deleteFiles,
  getAttachmentData,
} from "@/services/assessment";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import AreYouSureModal from "@/components/recommend/areYouSureModal.vue";
import { decryptFileBase64, decryptText, encryptFile } from "@/utils/cipher";
import { computed } from "vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Assessment } from "@/services/apiRoutes/routes";
import {
  deleteRequestAssessmentAttachment,
  deleteVendorRequestAssessmentAttachment,
  getRequestAssessmentAttachment,
  getRequestVendorAssessmentAttachment,
  postRequestAssessmentAttachment,
} from "@/services/vendor";
import { get } from "lodash";


export default /*#__PURE__*/_defineComponent({
  __name: 'modalAddEvidenceAssessment',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  value: {
    type: Object as PropType<IAssessmentQuestion>,
    default: () => ({}),
    required: true,
  },
  dataTableFile: {
    type: Array as PropType<IAssessmentQuestionFile[]>,
    default: () => [],
  },
  passkey: {
    type: String,
    default: "",
  },
  isVendorRequest: {
    type: String,
    default: "",
  },
},
  emits: ["update:show"],
  setup(__props, { emit }) {

const props = __props;




const passkeyQuestion = ref(props.passkey);
const isShowMoreActions = ref(false);
const handleShowBulkAction = () => {
  isShowMoreActions.value = !isShowMoreActions.value;
  if (selectedRow.value?.length < 1) {
    isShowMoreActions.value = false;
  }
};

const tableFileActions = computed(() =>
  isChecklistCompleted.value
    ? [actionClickType.actionDownload]
    : [actionClickType.actionRemoveFile, actionClickType.actionDownload],
);

const dataTableFileFormatted = ref([] as any[]);
const tableFileFields = [
  {
    text: getComponentUiText("app-component-custom-table-header-document-1"),
    value: "name",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<a data-cy="modal-evidence-asssessment-file-name" class="tw-text-[#387DFF] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal] tw-cursor-pointer">${value}</a>`,
    sortable: false,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-size-1"),
    value: "size",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-text-[#878787] tw-text-[13px] tw-not-italic tw-leading-[normal]">${value}</span>`,
    sortable: false,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-date-1"),
    value: "date",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-text-[#878787] tw-text-[13px] tw-not-italic tw-leading-[normal]">${value}</span>`,
    sortable: false,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-uploaded-by-1"),
    value: "uploadedBy",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "tw-w-[45px] !tw-pr-[16px]",
  },
];
const showRef = ref(props.show);
const file: Ref = ref(null);
const fileUploaderRef: Ref = ref(null);
const selectedRow: Ref<any[]> = ref([]);
const isModalImgShown = ref(false);
let urlAttachment = "";
const isCallApiGetImg = ref(false);
const MAX_EVID_SIZE = fileSizeFormat(
  process.env.VUE_APP_MAX_EVID_SIZE || 52428800,
);
const propsRemoveAttachmentsModal = ref({
  show: false,
  title: getComponentUiText(
    "app-assessment-input-modal-remove-attachment-header-1",
  ),
  description: getComponentUiText(
    "app-assessment-input-modal-remove-attachment-description-1",
  ),
  list: [
    getComponentUiText("app-assessment-notify-download-attachment-empty-1"),
  ],
  buttonText: getComponentUiText(
    "app-assessment-modal-remove-attachment-button-text-1",
  ),
});

watch(
  () => dataTableFileFormatted.value.length,
  (value) => {
    if (value === 0) {
      passkeyQuestion.value = "";
    }
  },
);

const isChecklistCompleted: ComputedRef<boolean> = computed(() => {
  const statusId =
    store.getters["Assessment/getChecklistInforDetail"].checklistStatusId;

  return (
    statusId === checklistStatusId.completed ||
    statusId === checklistStatusId.paused ||
    statusId === checklistStatusId.defunct
  );
});

const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};
const closeModalImg = () => {
  isModalImgShown.value = false;
};
const getAttachment = async (data) => {
  try {
    if (isCallApiGetImg.value) return;
    let res;
    if (props.isVendorRequest === CHECKLIST_TYPE.externalChecklist) {
      res = await store.dispatch(
        "Vendor/fetchVendorRequestedExternalAttachment",
        data.attachmentId || data.id,
      );
    } else {
      if (props.isVendorRequest === CHECKLIST_TYPE.reviewChecklist) {
        res = await store.dispatch(
          "Vendor/fetchVendorRequestedAttachment",
          data.attachmentId || data.id,
        );
      } else {
        res = await store.dispatch(
          "Assessment/getAttachment",
          data.attachmentId || data.id,
        );
      }
    }
    isCallApiGetImg.value = true;
    if (res.status === successStatusCodes.OK) {
      const fileDecrypted = await handleDecryptFile(
        res.data.data,
        passkeyQuestion.value ? passkeyQuestion.value : props.passkey,
      );

      if (!fileDecrypted.fileType.includes("image")) {
        downloadAttachment(data.attachmentId || data.id);
      } else {
        urlAttachment = `${fileDecrypted.file}`;
        isModalImgShown.value = true;
      }
    }
  } catch (error: any) {
    showError(error?.data?.error?.message || "error");
  } finally {
    isCallApiGetImg.value = false;
  }
};

const handleDecryptFile = async (file, passkeyQuestion) => {
  try {
    if (file) {
      const pwdFeIv = localStorage.getItem(localStorageKey.pwdFeIv) ?? "";
      const passkeyDecrypt = await decryptText(passkeyQuestion, pwdFeIv);

      const fileDecrypted = await decryptFileBase64(
        file,
        passkeyDecrypt ? passkeyDecrypt : passkeyQuestion,
      );

      if (fileDecrypted) {
        return fileDecrypted;
      } else {
        showError(
          "app-component-assessments-securing-evidence-modal-decrypt-error-1",
        );
      }
    }
  } catch (error: any) {
    showError(
      "app-component-assessments-securing-evidence-modal-decrypt-error-1",
    );
  }
};
const loadingImg = ref(API_STATUS_LOADING.NO_ACTION);
const uploadFile = async (file: File | null) => {
  file && (loadingImg.value = API_STATUS_LOADING.LOADING);
  if (!passkeyQuestion.value) {
    openSecuringModal(file);
  } else {
    handleFile(file);
  }
};

const openSecuringModal = (file: File | null) => {
  const emitData = {
    component: MODAL_NAME.MODAL_SECURING_EVIDENCE,
    properties: {
      type: TYPE_MODAL_SECURING_EVIDENCE.ENCRYPT,
      checklistItemId: props.value.checklistItemId,
      attachmentId: dataTableFileFormatted?.value.length
        ? dataTableFileFormatted.value[0].attachmentId ||
          dataTableFileFormatted.value[0].id
        : null,
      isVendorRequest: props.isVendorRequest,
    },
    events: {
      "update:data": (passkey) => {
        passkeyQuestion.value = passkey;
        handleFile(file);
      },
      "update:close": () => {
        refreshImage();
        loadingImg.value = API_STATUS_LOADING.SUCCESS;
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleFile = async (file: File | null) => {
  try {
    if (!file) {
      await refreshImage();
      showError(
        getComponentUiText(
          "app-component-assessment-modal-assessment-toast-added-fail-1",
        ),
      );
    } else {
      try {
        if (!ACCEPTABLE_FILE_TYPE.includes(file?.type)) {
          showError(
            getComponentUiText(
              "app-component-assessment-modal-assessment-toast-added-fail-1",
            ),
          );
          loadingImg.value = API_STATUS_LOADING.ERROR;
          return;
        }
        const formData: FormData = new FormData();
        const pwdFeIv = localStorage.getItem(localStorageKey.pwdFeIv) ?? "";
        const fileEncrypt = await encryptFile(
          file,
          passkeyQuestion.value ? passkeyQuestion.value : props.passkey,
          pwdFeIv,
        );
        if (!fileEncrypt) {
          showToastSuccess(
            getComponentUiText(
              "app-component-assessment-modal-assessment-toast-added-fail-1",
            ),
          );
          loadingImg.value = API_STATUS_LOADING.ERROR;
          return;
        }
        formData.append("file", fileEncrypt);
        let res;
        if (props.isVendorRequest) {
          res = await postRequestAssessmentAttachment(
            props.value.checklistId,
            props.value.checklistItemId,
            formData,
          );
        } else {
          res = await postUploadFile(props.value.checklistItemId, formData);
        }
        if (res.data?.data && res.status === successStatusCodes.OK) {
          if (props.isVendorRequest) {
            store.dispatch(
              "Vendor/addAttachmentItemChecklistRequestedExternalInput",
              {
                attachments: get(res, "data.data", []),
                checklistItemId: props.value.checklistItemId,
              },
            );
          }
          const newFile = await convertFileToDataFile(file, res.data.data);

          updateTableDataFile(newFile);

          await refreshImage();
          showToastSuccess(
            getComponentUiText(
              "app-component-assessment-modal-assessment-toast-added-1",
            ),
          );
        } else {
          showError(res.data.message);
        }
        loadingImg.value = API_STATUS_LOADING.SUCCESS;
      } catch (error: any) {
        loadingImg.value = API_STATUS_LOADING.ERROR;
        showErrorAPI(error, Assessment.checklistAttachment, error.status);
      }
    }
  } catch (error: any) {
    if (error && error.data) {
      showError(error);
    }
  }
};

const refreshImage = async () => {
  fileUploaderRef.value = null;
  file.value = null;
};

const showToastSuccess = (message) => {
  const emitData: IToastMessage = { variant: ToastVariant.SUCCESS, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const convertFileToDataFile = async (file: File, item) => {
  let currentUser,
    userName = "";
  let email = "";
  let addedByUserId = "";
  const attachmentId = item.attachmentId;

  if (props.isVendorRequest) {
    const checklistVendorRequestedExternalInput =
      store.state.Vendor.checklistVendorRequestedExternalInput;
    const emailGrantId = item.attachmentAddedByEmailGrantId || 0;
    const emailInfo =
      checklistVendorRequestedExternalInput.checklistRequestedEmailGrants.filter(
        (i) => i.emailGrantId === emailGrantId,
      );
    emailInfo[0]?.recipientEmail || "";
    return {
      ...item,
      name: item.fileNameOriginal,
      size: fileSizeFormat(item.fileSizeBytes),
      date: convertUTCTimeToLocalTime(
        item.attachmentDateAdded.toString(),
        undefined,
        "HH:mm",
      ),
      uploadedBy: { email: emailInfo[0]?.recipientEmail || "" },
    };
  }
  if (localStorage.getItem(localStorageKey.currentUserData)) {
    currentUser = JSON.parse(
      localStorage.getItem(localStorageKey.currentUserData) || "{}",
    );
  }

  const res = await store.dispatch(
    "Assessment/getUserUploadFile",
    currentUser.userId,
  );

  if (res?.data?.data && res.status === successStatusCodes.OK) {
    userName = `${res.data.data.firstName} ${res.data.data.lastName}`;
    email = res.data.data.email;
    addedByUserId = res.data.data.userId;
  }

  return {
    id: attachmentId ? attachmentId : Math.random() * 1000,
    name: file.name,
    type: file.type,
    size: fileSizeFormat(file.size),
    date: convertUTCTimeToLocalTime(new Date().toString(), undefined, "HH:mm"),

    uploadedBy: { nameText: userName, email },
    addedByUserId,
  };
};

const updateTableDataFile = (newData, remove = false) => {
  const fileIndex = dataTableFileFormatted.value.findIndex(
    (item) => item.id === newData.id,
  );
  if (remove) {
    dataTableFileFormatted.value = dataTableFileFormatted.value?.filter(
      (item) => item.id !== newData.attachmentId,
    );
    if (props.isVendorRequest === CHECKLIST_TYPE.externalChecklist) {
      store.dispatch(
        "Vendor/delAttachmentItemChecklistRequestedExternalInput",
        {
          attachmentIds: [newData.attachmentId],
          checklistItemId: props.value.checklistItemId,
        },
      );
    } else {
      if (props.isVendorRequest === CHECKLIST_TYPE.reviewChecklist) {
        store.dispatch("Vendor/delAttachmentItemChecklistRequestedInput", {
          attachmentIds: [newData.attachmentId],
          checklistItemId: props.value.checklistItemId,
        });
      }
    }
  } else if (fileIndex === -1 || !dataTableFileFormatted.value.length) {
    dataTableFileFormatted.value.push({
      ...newData,
      id: newData.id || newData.attachmentId,
    });
  } else dataTableFileFormatted.value[fileIndex] = newData;
  const data = dataTableFileFormatted.value;
  if (!props.isVendorRequest) {
    store.dispatch("Assessment/updateCheckListItem", {
      checklistItemId: props.value.checklistItemId,
      data,
      type: ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_ATTACHMENTS,
    });
  }
};

const handleTableDataFile = async () => {
  dataTableFileFormatted.value = await Promise.all(
    props.dataTableFile.map(async (item, index) => {
      let userName = "";
      let email = "";
      let addedByUserId = "";

      if (props.isVendorRequest) {
        email = item.uploadedBy?.email;
      } else {
        const res = await store.dispatch(
          "Assessment/getUserUploadFile",
          props.dataTableFile[index].addedByUserId,
        );

        if (res?.data?.data && res.status === successStatusCodes.OK) {
          userName = `${res.data.data.firstName} ${res.data.data.lastName}`;
          email = res.data.data.email;
          addedByUserId = res.data.data.userId;
        }
      }

      return {
        ...item,
        size: fileSizeFormat(item.size),
        date: convertUTCTimeToLocalTime(
          item.date.toString(),
          undefined,
          "HH:mm",
        ),
        addedByUserId,
        uploadedBy: {
          nameText: userName,
          email,
        },
      };
    }),
  );
};

const deleteAttachment = async (attachmentId) => {
  try {
    if (!attachmentId) return;
    let res;
    if (props.isVendorRequest === CHECKLIST_TYPE.externalChecklist) {
      res = await deleteRequestAssessmentAttachment(
        props.value.checklistId,
        props.value.checklistItemId,
        [attachmentId],
      );
    } else {
      if (props.isVendorRequest === CHECKLIST_TYPE.reviewChecklist) {
        res = await deleteVendorRequestAssessmentAttachment(
          props.value.checklistId,
          props.value.checklistItemId,
          [attachmentId],
        );
      } else {
        res = await deleteFiles([attachmentId]);
      }
    }
    if (res.status === successStatusCodes.OK) {
      updateTableDataFile({ attachmentId }, true);
      showToastSuccess(
        getComponentUiText(
          "app-component-assessment-modal-assessment-toast-delete-1",
        ),
      );
    }
  } catch (error: any) {
    showError(error?.message);
  }
};

const updateSelectedRows = (selectedRows: any[]) => {
  selectedRow.value = selectedRows;
  if (selectedRow.value.length < 1) {
    isShowMoreActions.value = false;
  }
};

const downloadAttachment = async (attachmentId: number) => {
  try {
    let res;
    if (props.isVendorRequest === CHECKLIST_TYPE.externalChecklist) {
      res = await getRequestAssessmentAttachment(attachmentId);
    } else {
      if (props.isVendorRequest === CHECKLIST_TYPE.reviewChecklist) {
        res = await getRequestVendorAssessmentAttachment(attachmentId);
      } else {
        res = await getAttachmentData(attachmentId);
      }
    }
    if (res.status === successStatusCodes.OK) {
      const fileDecrypted = await handleDecryptFile(
        res.data.data,
        passkeyQuestion.value ? passkeyQuestion.value : props.passkey,
      );

      utilities.downloadBase64File(
        fileDecrypted.fileName,
        fileDecrypted.file,
        fileDecrypted.fileMimeTypeDetected,
      );
      showToastSuccess(
        getComponentUiText(
          "app-component-assessment-modal-assessment-toast-download-1",
        ),
      );
    }
  } catch (error: any) {
    showError(error?.message);
  }
};

const initial = () => {
  handleTableDataFile();
};

onMounted(() => initial());

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

watch(
  () => props.dataTableFile,
  () => {
    handleTableDataFile();
  },
);

const showToast = (emitData: IToastMessage) => {
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const downloadAttachments = async () => {
  const attachmentIds = selectedRow.value;
  let status = "empty";
  if (attachmentIds?.length) {
    showToast({
      variant: ToastVariant.SUCCESS,
      message: getComponentUiText(
        "app-assessment-notify-download-attachment-start-1",
      ),
    });
    let propsPasskey = props.passkey;
    if (!props.isVendorRequest) {
      const pwdFeIv = localStorage.getItem(localStorageKey.pwdFeIv) ?? "";
      const passkeyDecrypt = await decryptText(propsPasskey, pwdFeIv);
      propsPasskey = passkeyDecrypt ? passkeyDecrypt : propsPasskey;
    }
    const isDownload = await store.dispatch("Assessment/downloadAttachments", {
      attachmentIds,
      passkey: passkeyQuestion.value || propsPasskey,
      isVendorRequest: props.isVendorRequest,
    });
    status = isDownload ? "success" : "error";
  }
  showToast({
    variant: status === "error" ? ToastVariant.ERROR : ToastVariant.SUCCESS,
    message: getComponentUiText(
      `app-assessment-notify-download-attachment-${status}-1`,
    ),
  });
};

const removeAttachments = async () => {
  const attachmentIds = selectedRow.value;
  let status = "empty";
  if (attachmentIds?.length) {
    let isDelete;
    if (props.isVendorRequest === CHECKLIST_TYPE.externalChecklist) {
      isDelete = await deleteRequestAssessmentAttachment(
        props.value.checklistId,
        props.value.checklistItemId,
        attachmentIds,
      );
      store.dispatch(
        "Vendor/delAttachmentItemChecklistRequestedExternalInput",
        {
          attachmentIds,
          checklistItemId: props.value.checklistItemId,
        },
      );
    } else {
      if (props.isVendorRequest === CHECKLIST_TYPE.reviewChecklist) {
        isDelete = await deleteVendorRequestAssessmentAttachment(
          props.value.checklistId,
          props.value.checklistItemId,
          attachmentIds,
        );
        store.dispatch("Vendor/delAttachmentItemChecklistRequestedInput", {
          attachmentIds,
          checklistItemId: props.value.checklistItemId,
        });
      } else {
        isDelete = await store.dispatch("Assessment/removeAttachments", {
          attachmentIds,
          selectedQuestions: [props.value.questionNumber],
        });
      }
    }
    status = isDelete ? "success" : "error";
    if (isDelete) {
      attachmentIds.forEach((attachmentId) =>
        updateTableDataFile({ attachmentId }, true),
      );
    }
  }
  showToast({
    variant: status === "error" ? ToastVariant.ERROR : ToastVariant.SUCCESS,
    message: getComponentUiText(
      `app-assessment-notify-remove-attachment-${status}-1`,
    ),
  });
};

const showModalRemoveAttachment = () => {
  const attachmentIds = selectedRow.value;
  if (!attachmentIds?.length) {
    return showToast({
      variant: ToastVariant.SUCCESS,
      message: getComponentUiText(
        `app-assessment-notify-remove-attachment-empty-1`,
      ),
    });
  }
  const attachments = dataTableFileFormatted.value.filter((item) =>
    selectedRow.value.includes(item.id),
  );
  propsRemoveAttachmentsModal.value.show = true;
  propsRemoveAttachmentsModal.value.list = attachments.map(
    (item, index) => `Attachment #${index + 1}: ${item.name}`,
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Modal, {
      class: "tw-translate-y-[-50%] assessment-modal tw-max-w-[1040px] tw-overflow-y-auto !tw-z-[1072] modal-evidence",
      visible: showRef.value,
      overlay: false,
      "overflow-y-scroll": true,
      onClose: handleCloseModal
    }, {
      default: _withCtx(() => [
        _createVNode(ModalHeader, {
          class: "modal-header",
          "data-cy-close": 'modal-add-evidence-assessment-close',
          title: 
        _unref(getComponentUiText)('app-component-assessments-evidence-modal-title-1')
      ,
          onClose: handleCloseModal
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(props.value.category), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(props.value.subCategory), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(props.value.questionNumber), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(props.value.questionTitle), 1)
          ])
        ]),
        (
        !isChecklistCompleted.value &&
        __props.isVendorRequest !== _unref(CHECKLIST_TYPE).reviewChecklist
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
            "app-component-assessments-evidence-modal-upload-file-title-1",
          )), 1)
              ]),
              _createVNode(FileUploader, {
                ref_key: "fileUploaderRef",
                ref: fileUploaderRef,
                file: file.value,
                "onUpdate:file": [
                  _cache[0] || (_cache[0] = ($event: any) => ((file).value = $event)),
                  uploadFile
                ],
                class: "!tw-max-w-[100%]",
                crop: false,
                "on-loading": loadingImg.value,
                guidance: 
          _unref(getComponentUiText)(
            'app-component-assessments-evidence-modal-upload-file-guidance-1',
            false,
            { maxSize: _unref(MAX_EVID_SIZE) },
          )
        ,
                "crop-modal-title": 
          _unref(getComponentUiText)(
            'app-settings-organisation-profile-avatar-cropper-heading-1',
          )
        ,
                "crop-formats": 
          _unref(getComponentUiText)(
            'app-settings-organisation-profile-avatar-cropper-formats-1',
            false,
            { maxSize: _unref(MAX_EVID_SIZE) },
          )
        ,
                "font-size-title": 12,
                "is-evidence": true,
                "is-multiple": true,
                onOnImageRemove: refreshImage
              }, null, 8, ["file", "on-loading", "guidance", "crop-modal-title", "crop-formats"])
            ]))
          : _createCommentVNode("", true),
        (dataTableFileFormatted.value?.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([`tw-mb-[30px] ${
        isChecklistCompleted.value ||
        __props.isVendorRequest === _unref(CHECKLIST_TYPE).reviewChecklist
          ? 'tw-mt-[30px]'
          : 'tw-mt-[-10px]'
      }`, "tw-mt-[-10px] tw-mb-[30px]"])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(getComponentUiText)(
            "app-component-assessments-evidence-modal-upload-table-title-1",
          )), 1),
                _createElementVNode("div", { onClick: handleShowBulkAction }, [
                  _createVNode(ButtonBulkActions, {
                    active: selectedRow.value?.length >= 1,
                    "show-more-actions": isShowMoreActions.value,
                    "show-acction-click": true,
                    "button-class": '!tw-border-[1px] !tw-border-solid !tw-border-[#EFF0F1] tw-mr-0',
                    "id-popover": 'popover-modal-add-evidence-assessment',
                    "selected-number": selectedRow.value?.length
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CustomDropDownItem, {
                        style: 'normal',
                        "id-text": 'app-common-action-download-title-1',
                        onClick: downloadAttachments
                      }),
                      (!isChecklistCompleted.value)
                        ? (_openBlock(), _createBlock(CustomDropDownItem, {
                            key: 0,
                            style: 'danger',
                            "id-text": 'app-component-assessments-evidence-modal-file-table-action-delete-1',
                            onClick: showModalRemoveAttachment
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["active", "show-more-actions", "selected-number"])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(CustomTable, {
                  columns: tableFileFields,
                  data: dataTableFileFormatted.value,
                  "empty-text": 
            _unref(getComponentUiText)(
              'app-component-assessments-evidence-modal-file-table-empty-1',
            )
          ,
                  onUpdateSelectedRows: updateSelectedRows,
                  onCurrentImage: getAttachment
                }, {
                  "cell(uploadedBy)": _withCtx((data) => [
                    _createVNode(CellTableInfo, {
                      value: data.value
                    }, null, 8, ["value"])
                  ]),
                  "cell(action)": _withCtx((data) => [
                    _createVNode(CellTableAction, {
                      id: 
                'assessment-question-sub-category-' +
                dataTableFileFormatted.value[data.idx].attachmentId
              ,
                      value: data,
                      "is-internal": true,
                      actions: tableFileActions.value,
                      onManageUser: 
                (value, action, isInternal) => {
                  if (action === _unref(actionClickType).actionDownload) {
                    downloadAttachment(value.attachmentId || value.id);
                  } else if (action === _unref(actionClickType).actionRemoveFile) {
                    deleteAttachment(data.item.attachmentId || data.item.id);
                  }
                }
              
                    }, null, 8, ["id", "value", "actions", "onManageUser"])
                  ]),
                  _: 1
                }, 8, ["data", "empty-text"])
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    (showRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14))
      : _createCommentVNode("", true),
    (isModalImgShown.value)
      ? (_openBlock(), _createBlock(ModalImage, {
          key: 1,
          onCloseModal: closeModalImg
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(urlAttachment),
              style: {"object-fit":"contain","width":"100%","height":"100%"},
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, null, 8, _hoisted_15)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(AreYouSureModal, _mergeProps(propsRemoveAttachmentsModal.value, {
      "onUpdate:data": removeAttachments,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (propsRemoveAttachmentsModal.value.show = false))
    }), null, 16)
  ], 64))
}
}

})